import { ContainerModule } from "inversify";
import * as Api from "@/app/interaction/api";
import * as SerializationApi from '@/app/state-serialization/api';
import ClickImageComponent from "./click-image-component.vue";
import { ClickImageStateProtobufSerializer } from "./click-image-state-protobuf-serializer";
import { IncludeClickImageHandler } from './include-click-image-handler';

export const clickImageFactoryModule = new ContainerModule(bind => {
  bind<Api.InteractiveComponentPlugin>(Api.InteractiveComponentPluginSymbol)
    .toConstantValue(ClickImageComponent)
    .whenTargetNamed("click-image");

  bind<Api.IncludeComponentsHandlerInterface>(Api.IncludeComponentsHandlerSymbol).to(IncludeClickImageHandler);
  bind(SerializationApi.StateSerializationPluginSymbol).to(ClickImageStateProtobufSerializer)
});
